/**
 * Install and offline (Phase 10): registers the service worker (/sw.js,
 * frontend/pwa/sw.js) and shows a banner while the device is offline.
 * Registration is skipped in tests and on file:// pages.
 */
function registerServiceWorker() {
  if (!("serviceWorker" in navigator) || !/^https?:$/.test(location.protocol)) return;
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js", { scope: "/" }).catch((e) => console.info("Offline support unavailable:", e.message));
  });
}

function offlineBanner() {
  const show = () => {
    let el = document.getElementById("offline-banner");
    if (navigator.onLine) { if (el) el.remove(); return; }
    if (el) return;
    el = document.createElement("div");
    el.id = "offline-banner";
    el.setAttribute("role", "status");
    el.textContent = "You're offline. Your game is saved; actions need the server and will work again when you reconnect.";
    document.body.appendChild(el);
  };
  window.addEventListener("online", show);
  window.addEventListener("offline", show);
  show();
}

// Node-based tests load modules without a real browser window: skip there.
if (typeof window !== "undefined" && typeof window.addEventListener === "function" && typeof navigator !== "undefined") {
  registerServiceWorker();
  offlineBanner();
}

export { offlineBanner, registerServiceWorker };
